// extracted by mini-css-extract-plugin
export var section = "Section-module--section--6GaWo";
export var light = "Section-module--light--2BT9E";
export var diagonal = "Section-module--diagonal--23FD0";
export var diagonal2 = "Section-module--diagonal2--2ftzz";
export var content = "Section-module--content--2EmJG";